import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "billing-codes-table",
  templateUrl: "billing-codes-table.html",
})
export class BillingCodesTable implements OnInit, OnDestroy {
  @Input() description: any;
  @Input() billingCodes: any[];
  @Input() useMedicareBillingCodes: boolean;
  @Input() isHospice: boolean;
  @Input() showVisitsDiv: boolean = false;
  @Input() showHCPCSCodes: boolean = false;
  @Input() disableCodes: boolean;
  @Input() editMode: boolean;
  @Output() validateFields = new EventEmitter<boolean>();
  visitRateErrors: any[];

  ngOnDestroy(): void {}

  ngOnInit(): void {
    this.visitRateErrors = [];
  }

  constructor() {}

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  alphanumericOnlyValidation(event: any) {
    const pattern = /[a-zA-Z0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  rateChanged(visitRate, i) {
    this.visitRateErrors[i] = this.checkValidModifiers(visitRate);
    let found = this.visitRateErrors.filter(
      (e) => e === "lengthError" || e === "orderError"
    );
    this.validateFields.emit(found.length == 0);
  }

  checkValidModifiers(visitRate) {
    if (
      (visitRate.M1 && visitRate.M1.length == 1) ||
      (visitRate.M2 && visitRate.M2.length == 1) ||
      (visitRate.M3 && visitRate.M3.length == 1) ||
      (visitRate.M4 && visitRate.M4.length == 1)
    )
      return "lengthError";

    if (visitRate.M4 && visitRate.M4.length > 0) {
      return visitRate.M3 &&
        visitRate.M3.length > 0 &&
        visitRate.M2 &&
        visitRate.M2.length > 0 &&
        visitRate.M1 &&
        visitRate.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitRate.M3 && visitRate.M3.length > 0) {
      return visitRate.M2 &&
        visitRate.M2.length > 0 &&
        visitRate.M1 &&
        visitRate.M1.length > 0
        ? ""
        : "orderError";
    } else if (visitRate.M2 && visitRate.M2.length > 0) {
      return visitRate.M1 && visitRate.M1.length > 0 ? "" : "orderError";
    }

    return "";
  }
}



// WEBPACK FOOTER //
// ./src/components/payers/billing-codes/billing-codes-table/billing-codes-table.ts